export const iconFontAwesomeEmojiFaceKiss = (
	<i className="fa-solid fa-face-kiss"></i>
);
